import React from 'react'

import { useSaveMask } from './_requests/saveMask'
import Form from '../../../packages/kiti/components/form/form/Form'
import GeneralSection from './sections/generalSection'
import SubmitBar from '../../../packages/kiti/components/form/SubmitBar'
import { useMasks } from './_load/MasksLoader'

const EditMaskForm = () => {
  const masks = useMasks()

  const [onSubmit, { loading, error }] = useSaveMask()

  return (
    <Form loading={loading} onSubmit={onSubmit} initialState={masks || {}}>
      <GeneralSection />
      <SubmitBar loading={loading} error={error} />
    </Form>
  )
}

export default EditMaskForm
